import React from 'react';
import './RadioButton.css';

class RadioButton extends React.Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(event) {
    //console.log('event target', event.target);
    this.props.handleClick(event);
  }

  render() {
    return (
      <div
        className={this.props.disabled ? 'RadioButton RadioButton--disabled' : this.props.active ? 'RadioButton RadioButton--active' : 'RadioButton'}
        onClick={this.handleClick}
        data-specific={!this.props.disabled && this.props.data}
        >
        {this.props.title}
      </div>
    )
  }

}

export default RadioButton;



// WEBPACK FOOTER //
// ./src/RadioButton.js